import TwoCol_ImageContentSection from './TwoCol_ImageContentSection';

export default TwoCol_ImageContentSection;
